// src/components/ClearChatDialog.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button } from '@mui/material';

const ClearChatDialog = ({ open, onClose, onConfirm, chatPartnerName }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Clear Chat History?</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to clear your copy of the conversation with <strong>{chatPartnerName}</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          This will only remove the messages from your view. Your chat partner will still be able to see the full history. This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: '0 24px 24px' }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          Clear
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClearChatDialog;